<template>
  <div v-if="reminder">

    <div class="flex flex-wrap -mx-2">
      <div class="w-full lg:w-1/3 xl:w-1/4 px-2">
        <div class="box">
          <div v-if="reminder.contact">
            <p class="text-lg text-theme-darker light:text-theme-lighter my-4 border-b border-theme-200 light:border-theme-600">
              Customer information
            </p>
            <contact-information
              :contact="reminder.contact"
              contact-type="customer"
              :edit="true"
              :link-to-contact="true"
              @updated="get"
            ></contact-information>
          </div>
          <div v-if="reminder.list">
            <p class="text-lg text-theme-darker light:text-theme-lighter my-4 border-b border-theme-200 light:border-theme-600">
              List information
            </p>
            <p class="text-xs">#{{ reminder.list.id }}</p>
            <p class="text-2xl font-bold">
              {{ reminder.list.name }}
            </p>

            <div class="mt-4">
              <p class="font-bold text-sm">Created at:</p>
              <p>{{ reminder.list.created_at }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-2/3 xl:w-3/4 px-2">
        <div class="box">

          <div class="flex flex-wrap items-end justify-between border-b border-theme-200 light:border-theme-600 pb-2">
            <p class="text-2xl font-bold leading-none">{{ reminder.method }}</p>
            <div>
              <button
                type="button"
                class="btn btn-orange text-xs text-black"
                @click="$router.push('/reminder/edit/' + reminder.id)"
                v-if="!reminder.date_sent && isFutureDate"
              >
                <i class="fas fa-edit"></i>
                <span class="ml-1">Edit</span>
              </button>
              <button
                type="button"
                class="btn btn-red text-xs text-black ml-2"
                @click.stop="deleteReminder(reminder.id)"
                v-if="!reminder.date_sent"
              >
                <i class="fas fa-trash"></i>
                <span class="ml-1">Delete</span>
              </button>
            </div>
          </div>

          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2">
              <div class="leading-tight">
                <p class="font-bold text-xs mt-4">To:</p>
                <p class="text-xl">
                  <span v-if="reminder.method === 'e-mail'">{{ reminder.contact.email }}</span>
                  <span v-if="reminder.method === 'sms'">+{{ CountryByID(sendToPhoneNumber.country_id).calling_code }} {{ sendToPhoneNumber.number }}</span>
                  <span v-if="reminder.list">List #{{ reminder.list.id }} {{ reminder.list.name }}</span>
                </p>

                <p class="font-bold text-xs mt-4">Due date:</p>
                <p class="text-xl">
                  {{ $moment(reminder.due_date).format(config.dateTimeFormats.display) }}
                  <span class="text-muted" v-if="isFutureDate">({{ $moment(reminder.due_date).fromNow() }})</span>
                  <span class="text-muted" v-else-if="!reminder.date_sent">(should have been sent {{ $moment(reminder.due_date).fromNow() }})</span>
                </p>

                <template v-if="reminder.date_sent">
                  <p class="font-bold text-xs mt-4">Date sent:</p>
                  <p class="text-xl">
                    {{ $moment(reminder.date_sent).format(config.dateTimeFormats.display) }}
                    <span class="text-muted">({{ $moment(reminder.date_sent).fromNow() }})</span>
                  </p>
                </template>

              </div>
            </div>
            <div class="w-full md:w-1/2">
              <template v-if="reminder.subject">
                <p class="font-bold text-xs mt-4">Subject:</p>
                <p class="text-xl">{{ reminder.subject }}</p>
              </template>

              <p class="font-bold text-xs mt-4">Content:</p>
              <pre class="text-black bg-white p-2 whitespace-normal rounded-sm">{{ reminder.content }}</pre>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="box" v-if="reminder.list">
      <p class="text-lg text-theme-darker light:text-theme-lighter">
        List recipients:
      </p>
      <div class="w-full overflow-x-auto">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Contact</th>
              <th>Method</th>
              <th>Destination</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(recipient, i) in reminder.list.recipients" :key="'reminder-list-recipient' + i">
              <td class="font-bold">{{ recipient.id }}</td>
              <td>
                #{{ recipient.contact.id }} {{ recipient.contact.first_name }} {{ recipient.contact.last_name }}
                <template v-if="recipient.contact.company_name"> ({{ recipient.contact.company_name }})</template>
              </td>
              <td>{{ recipient.method }}</td>
              <td>
                <template v-if="recipient.method === 'sms'">
                  +{{ CountryByID(recipient.phone_number.country_id).calling_code }} {{ recipient.phone_number.number }}
                </template>
                <template v-if="recipient.method === 'e-mail'">
                  {{ recipient.contact.email }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const ContactInformation = resolve => require(['@/components/pages/ContactInformation'], resolve)

export default {
  components: {
    ContactInformation,
  },
  data() {
    return {
      reminderID: this.$route.params.reminderID,
      reminder: {},
      prints: {
        remarks: null,
      },
    }
  },
  computed: {
    isFutureDate() {
      return this.$moment().isBefore(this.reminder.due_date)
    },
    sendToPhoneNumber() {
      if (this.reminder.method !== 'sms') {
        return false
      }
      return this.reminder.contact.phone_numbers.filter(p => p.id === this.reminder.contact_phone_number_id)[0] || false
    },
    ...mapGetters({
      CountryByID: 'countries/countryByID',
      config: 'config/config',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    deleteReminder(reminderID) {
      this.$swal.fire({
        title: 'Delete reminder',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            // send delete
            axios.delete('reminders/' + reminderID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.$router.push('/reminder/list')
              })
          }
        })
    },
    get() {
      axios.get('reminders/' + this.reminderID)
        .then((response) => {
          const reminder = response.data

          this.reminder = Object.assign({}, reminder)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Reminder not found',
            type: 'warning',
          })
        })
    },
  }
}
</script>
